export default __webpack_public_path__ + "static/media/lb.86431875.svg";